const setGraphData_open_newsell = payload => {
  return {
    type: "setGraphData_open_newsell",
    payload
  };
};
export default setGraphData_open_newsell;
